export const START_DISCARD_TIME = 'REDUX_START_DISCARD_TIME';
export const PAUSE_DISCARD_TIME = 'REDUX_PAUSE_DISCARD_TIME';
export const RESET_DISCARD_TIME = 'REDUX_RESET_DISCARD_TIME';
export const DECREASE_DISCARD_TIME = 'REDUX_DECREASE_DISCARD_TIME';

export const actionStartDiscardTime = (dispatch, timerid) => {
    dispatch({ type: START_DISCARD_TIME, payload: { timerid: timerid } });
};

export const actionPauseDiscardTime = (dispatch) => {
    dispatch({ type: PAUSE_DISCARD_TIME });
};

export const actionDecreaseDiscardTime = (dispatch) => {
    dispatch({ type: DECREASE_DISCARD_TIME });
};

export const actionResetDiscardTime = (dispatch) => {
    dispatch({ type: RESET_DISCARD_TIME });
};